const { isEmpty } = require('lodash');

const { boxSizes, deliveryTypes, deliveryCarriers, } = require('../config');

const { keys, entries, } = Object;
const shippingSizeOptions = entries(boxSizes).map(([k, v]) => ({ label: v.label, value: k, }));

const printerFields = () => {
  return {
    location: {
      label: 'ロケーションラベル',
      type: 'string',
      validations: {
        required: _ => !isEmpty(_),
      },
    },
    receivementProduct: {
      label: '入荷時の商品ラベル',
      type: 'string',
      validations: {
        required: _ => !isEmpty(_),
      },
    },
    amazonProductShipment: {
      label: 'Amazon商品の配送ラベル',
      type: 'string',
    },
    other: {
      label: 'その他ラベル',
      type: 'string',
      validations: {
        required: _ => !isEmpty(_),
      },
    },
  };
};

const amazonShippingRequestDocumentNumbersSettingFields = () => {
  return {
    start: {
      label: '開始値',
      type: 'integer',
      validations: {
        greaterThanOrEqualTo0: _ => _ >= 0,
      },
    },
    end: {
      label: '終了値',
      type: 'integer',
      validations: {
        greaterThanOrEqualTo0: _ => _ >= 0,
      },
    },
    current: {
      label: '現在値',
      type: 'integer',
      validations: {
        greaterThanOrEqualTo0: _ => _ >= 0,
      },
    },
  };
};

const generalSettingFields = () => {
  return {
    storageStartDays: {
      label: '保管料計上開始日(入荷からn日後)',
      type: 'integer',
      initialValue: 2,
      validations: {
        greaterThanOrEqualTo0: _ => _ != null && _ >= 0,
      },
    },
    defaultDeliveryCarrier: {
      label: 'デフォルトの配送キャリア',
      type: 'select',
      options: deliveryCarriers.map(_ => ({ label: deliveryTypes[_].label, value: _, })),
      validations: {
        required: _ => !isEmpty(_),
      },
    },
    toBeDeliveryCarrier: {
      label: 'toB出荷の配送キャリア',
      type: 'select',
      options: deliveryCarriers.map(_ => ({ label: deliveryTypes[_].label, value: _, })),
      validations: {
        required: _ => !isEmpty(_),
      },
    },
    rule1DeliveryCarrier: {
      label: '[ルール1] 配送キャリア',
      type: 'select',
      options: deliveryCarriers.map(_ => ({ label: deliveryTypes[_].label, value: _, })),
    },
    rule1PostalCodes: {
      label: '[ルール1] 郵便番号',
      type: 'text',
    },
    rule1ShippingSizes: {
      label: '[ルール1] 出荷サイズ',
      type: 'multiSelect',
      options: shippingSizeOptions,
      hint: '該当サイズの商品一つのみの出荷依頼がマッチします',
    },
    rule2DeliveryCarrier: {
      label: '[ルール2] 配送キャリア',
      type: 'select',
      options: deliveryCarriers.map(_ => ({ label: deliveryTypes[_].label, value: _, })),
    },
    rule2PostalCodes: {
      label: '[ルール2] 郵便番号',
      type: 'text',
    },
    rule2ShippingSizes: {
      label: '[ルール2] 出荷サイズ',
      type: 'multiSelect',
      options: shippingSizeOptions,
      hint: '該当サイズの商品一つのみの出荷依頼がマッチします',
    },
    rule3DeliveryCarrier: {
      label: '[ルール3] 配送キャリア',
      type: 'select',
      options: deliveryCarriers.map(_ => ({ label: deliveryTypes[_].label, value: _, })),
    },
    rule3PostalCodes: {
      label: '[ルール3] 郵便番号',
      type: 'text',
    },
    rule3ShippingSizes: {
      label: '[ルール3] 出荷サイズ',
      type: 'multiSelect',
      options: shippingSizeOptions,
      hint: '該当サイズの商品一つのみの出荷依頼がマッチします',
    },
    rule4DeliveryCarrier: {
      label: '[ルール4] 配送キャリア',
      type: 'select',
      options: deliveryCarriers.map(_ => ({ label: deliveryTypes[_].label, value: _, })),
    },
    rule4PostalCodes: {
      label: '[ルール4] 郵便番号',
      type: 'text',
    },
    rule4ShippingSizes: {
      label: '[ルール4] 出荷サイズ',
      type: 'multiSelect',
      options: shippingSizeOptions,
      hint: '該当サイズの商品一つのみの出荷依頼がマッチします',
    },
    rule5DeliveryCarrier: {
      label: '[ルール5] 配送キャリア',
      type: 'select',
      options: deliveryCarriers.map(_ => ({ label: deliveryTypes[_].label, value: _, })),
    },
    rule5PostalCodes: {
      label: '[ルール5] 郵便番号',
      type: 'text',
    },
    rule5ShippingSizes: {
      label: '[ルール5] 出荷サイズ',
      type: 'multiSelect',
      options: shippingSizeOptions,
      hint: '該当サイズの商品一つのみの出荷依頼がマッチします',
    },
  };
};

module.exports = {
  printerFields,
  amazonShippingRequestDocumentNumbersSettingFields,
  generalSettingFields,
};
